module.exports = __webpack_public_path__ + "media/A_amb_tutorial_loop.777c1e12.mp3";